import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ff8dd12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-main-content" }

import { computed } from 'vue';
import { useTagsStoreHook } from '@/store/modules/tags';
import { useLayoutStoreHook } from '@/store/modules/layout';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const cachePageList = useTagsStoreHook().cachePageList;
const layoutStore = useLayoutStoreHook();

const styleC = computed(() => {
  const { layout, opened } = layoutStore;
  if (layout === 'horizontal') {
    return {};
  }
  return {
    'padding-left': opened ? '210px' : '54px',
  };
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("section", {
    class: "app-main",
    style: _normalizeStyle(_unref(styleC))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component, route }) => [
          _createVNode(_Transition, {
            name: "fade-slide",
            mode: "out-in",
            appear: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_KeepAlive, { include: _unref(cachePageList) }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                  key: route.fullPath
                }))
              ], 1032, ["include"]))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ])
  ], 4))
}
}

})